import { render, staticRenderFns } from "./BaseDrawer.vue?vue&type=template&id=5a18b6d7&scoped=true"
import script from "./BaseDrawer.vue?vue&type=script&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&lang=js"
import style0 from "./BaseDrawer.vue?vue&type=style&index=0&id=5a18b6d7&prod&lang=css"
import style1 from "./BaseDrawer.vue?vue&type=style&index=1&id=5a18b6d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18b6d7",
  null
  
)

export default component.exports